export default "__VITE_ASSET__nEfJC9yd__"